/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedResponse_PerformanceCategoryResponse_ } from '../models/PaginatedResponse_PerformanceCategoryResponse_';
import type { PerformanceCategoryCreateRequest } from '../models/PerformanceCategoryCreateRequest';
import type { PerformanceCategoryResponse } from '../models/PerformanceCategoryResponse';
import type { PerformanceCategorySortRequest } from '../models/PerformanceCategorySortRequest';
import type { PerformanceCategoryUpdateRequest } from '../models/PerformanceCategoryUpdateRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PerformanceCategoryService {
    /**
     * Create Performance Category
     * 성과 분류 생성
     *
     * 새로운 성과 분류를 생성합니다.
     * @returns PerformanceCategoryResponse Created
     * @throws ApiError
     */
    public static appsPerformanceViewsCreatePerformanceCategory({
        requestBody,
    }: {
        requestBody: PerformanceCategoryCreateRequest,
    }): CancelablePromise<PerformanceCategoryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/performance/category',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List Performance Categories
     * 성과 분류 목록 조회 및 검색
     *
     * 성과 분류를 페이징하여 조회합니다. 검색 키워드가 제공되면 검색을 수행합니다.
     *
     * Args:
     * workspace_id: 워크스페이스 ID로 필터링 (선택사항)
     * business_id: 사업 ID로 필터링 (선택사항)
     * parent_id: 상위 분류 ID로 필터링 (선택사항)
     * q: 검색 키워드 (선택사항) - 분류명, 공식으로 검색
     * @returns PaginatedResponse_PerformanceCategoryResponse_ OK
     * @throws ApiError
     */
    public static appsPerformanceViewsListPerformanceCategories({
        workspaceId,
        businessId,
        parentId,
        q,
        page = 1,
        perPage = 100,
    }: {
        workspaceId?: string,
        businessId?: string,
        parentId?: string,
        q?: string,
        page?: number,
        perPage?: number,
    }): CancelablePromise<PaginatedResponse_PerformanceCategoryResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/performance/category',
            query: {
                'workspace_id': workspaceId,
                'business_id': businessId,
                'parent_id': parentId,
                'q': q,
                'page': page,
                'per_page': perPage,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Performance Category
     * 성과 분류 조회
     *
     * ID로 특정 성과 분류를 조회합니다.
     * @returns PerformanceCategoryResponse OK
     * @throws ApiError
     */
    public static appsPerformanceViewsGetPerformanceCategory({
        categoryId,
    }: {
        categoryId: string,
    }): CancelablePromise<PerformanceCategoryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/performance/category/{category_id}',
            path: {
                'category_id': categoryId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update Performance Category
     * 성과 분류 정보 수정
     *
     * 특정 성과 분류의 정보를 수정합니다.
     * @returns PerformanceCategoryResponse OK
     * @throws ApiError
     */
    public static appsPerformanceViewsUpdatePerformanceCategory({
        categoryId,
        requestBody,
    }: {
        categoryId: string,
        requestBody: PerformanceCategoryUpdateRequest,
    }): CancelablePromise<PerformanceCategoryResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/performance/category/{category_id}',
            path: {
                'category_id': categoryId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete Performance Category
     * 성과 분류 삭제
     *
     * 특정 성과 분류를 삭제합니다. (소프트 삭제)
     * @returns void
     * @throws ApiError
     */
    public static appsPerformanceViewsDeletePerformanceCategory({
        categoryId,
    }: {
        categoryId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/performance/category/{category_id}',
            path: {
                'category_id': categoryId,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update Performance Category Sort
     * 성과 분류 정렬 순서 변경
     *
     * 성과 분류의 정렬 순서를 변경합니다.
     * prev_category_id: 이동할 위치의 이전 분류 ID (맨 앞이면 None)
     * next_category_id: 이동할 위치의 다음 분류 ID (맨 뒤면 None)
     * @returns PerformanceCategoryResponse OK
     * @throws ApiError
     */
    public static appsPerformanceViewsUpdatePerformanceCategorySort({
        categoryId,
        requestBody,
    }: {
        categoryId: string,
        requestBody: PerformanceCategorySortRequest,
    }): CancelablePromise<PerformanceCategoryResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/performance/category/{category_id}/sort',
            path: {
                'category_id': categoryId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
